export interface PopupData {
    title: string,
    content: string,
    warn: boolean,
    cancelBtnText: string,
    okayBtnText: string,
    okayBtnRedirect: string,
    cancelBtnRedirect: string
}

export var initPopupData: PopupData = {
    title: '',
    content: '',
    warn: false,
    cancelBtnText: '',
    okayBtnText: '',
    okayBtnRedirect: '',
    cancelBtnRedirect: ''
}